import { render } from "./News.vue?vue&type=template&id=0cd30127&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=0cd30127&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd30127"]])

export default __exports__